// extracted by css-extract-rspack-plugin
export default {"tableSortLabel":"TableHeadSorter_tableSortLabel__Ph4yk"};